export { SpaClassesV2Connected as SpaClassesV2 } from './container';
export { SpaClassBookingV2 } from './SpaClassBookingV2';
